import { baseQuery } from "api/config";
import { createApi } from "@reduxjs/toolkit/query/react";
import { endpoints } from "api/endpoints";

export const api = createApi({
  baseQuery,
  refetchOnMountOrArgChange: true,
  refetchOnFocus: true,
  tagTypes: [],
  endpoints(build) {
    return {
      getChargeBackListById: build.query({
        query: (id) => ({
          url: endpoints.getChargeBackListById(id),
          method: "GET",
        }),
      }),
      acceptChargeBack: build.mutation({
        query: (id) => ({
          url: endpoints.acceptChargeBack(id),
          method: "PUT",
        }),
      }),
      disputeChargeBack: build.mutation({
        query: ({ id, data }) => ({
          url: endpoints.disputeChargeBack(id),
          method: "PUT",
          body: data,
        }),
      }),
      getProviderConfig: build.query({
        query: () => ({
          url: endpoints.getProviderConfig(),
          method: "GET",
        }),
      }),
    }
  },
});


export const {
  useLazyGetChargeBackListByIdQuery,
  useLazyGetProviderConfigQuery,
  useDisputeChargeBackMutation,
  useAcceptChargeBackMutation,
} = api;
